import terms_md from './docs/terms.md?raw'
import privacy_md from './docs/privacy.md?raw'
import cookies_md from './docs/cookies.md?raw'
import copyright_md from './docs/copyright.md?raw'
import community_md from './docs/community.md?raw'
import creator_program_md from './docs/creator_program.md?raw'
import brand_advertising_md from './docs/brand_advertising.md?raw'
import payment_md from './docs/payment.md?raw'

import config_ext from '../../../../config_ext.js'

type Legal_block = {t: 'h2', id: string, text: string} | {t: 'h3', text: string}
  | {t: 'ul', items: string[]} | {t: 'p', text: string}

let str2id = (s: string)=>s.toLowerCase().replace(/[^a-z0-9]+/gu, '-')
  .replace(/^-|-$/gu, '')

let md_clean = (s: string)=>s.replace(/^_(.*)_$/u, '$1').trim()

let md_parse = (md: string)=>{
  let title = '', blocks: Legal_block[] = []
  let para: string[] = [], ul: string[] = []
  let flush = ()=>{
    if (para.length)
      blocks.push({t: 'p', text: para.join(' ')})
    if (ul.length)
      blocks.push({t: 'ul', items: ul})
    para = []
    ul = []
  }
  for (let line of md.split('\n')) {
    let l = line.trim()
    let m
    if (!l) {
      flush()
      continue
    }
    if ((m = /^# (.*)/u.exec(l))) {
      title = m[1]
      continue
    }
    if ((m = /^## (.*)/u.exec(l))) {
      flush()
      blocks.push({t: 'h2', id: str2id(m[1]), text: m[1]})
      continue
    }
    if ((m = /^### (.*)/u.exec(l))) {
      flush()
      blocks.push({t: 'h3', text: m[1]})
      continue
    }
    if ((m = /^[-*] (.*)/u.exec(l))) {
      if (para.length)
        flush()
      ul.push(md_clean(m[1]))
      continue
    }
    if (ul.length)
      flush()
    para.push(md_clean(l))
  }
  flush()
  return {title, blocks}
}

let docs_raw = [
  {slug: 'terms', lbl: 'Terms of Service', md: terms_md},
  {slug: 'privacy', lbl: 'Privacy Policy', md: privacy_md},
  {slug: 'cookies', lbl: 'Cookie Policy', md: cookies_md},
  {slug: 'copyright', lbl: 'Copyright & DMCA Policy', md: copyright_md},
  {slug: 'community', lbl: 'Community Guidelines', md: community_md},
  {slug: 'creator_program', lbl: 'Creator Program Policy',
    md: creator_program_md},
  {slug: 'brand_advertising', lbl: 'Brand Advertising Policy',
    md: brand_advertising_md},
  {slug: 'payment', lbl: 'Payment & Billing Policy', md: payment_md},
]

export let legal_docs = docs_raw.map(({slug, lbl, md})=>{
  let {blocks} = md_parse(md)
  return {slug, lbl, title: lbl, meta: [`Version: ${config_ext.ver}`], blocks}
})